<template>
  <nav
    ref="quickRef"
    :class="[
      'c-quick',
      { 'is-expanded': data.popup.isMoQuickExpanded },
      { 'has-bottom-fixed': hasButtonFixed },
    ]"
  >
    <div class="quick-inner">
      <a
        href="javascript:void(0);"
        class="btn-top"
        @click="btnCmd('handleGoto')"
      >
        <span class="sr-only">상단으로 이동</span>
      </a>
      <!-- D: 2024-12-23 MO전용 버튼 추가-->
      <a
        href="javascript:void(0);"
        @click="btnCmd('orderBasket')"
        class="quick-basket"
      >
        <span class="sr-only">장바구니</span>
        <div class="c-count" v-if="isBasketCount">
          <span>{{ dispBasketCount }}</span>
        </div>
      </a>
      <button
        type="button"
        class="quick-expand"
        @click="btnCmd('handleExpand')"
      >
        <span class="sr-only"
          >메뉴 {{ data.popup.isMoQuickExpanded ? "닫힘" : "펼침" }}</span
        >
      </button>
      <!-- // D: 2024-12-23 MO전용 버튼 추가 -->
      <!-- D: 2024-12-23 div Wrap 래핑 추가 -->
      <div class="quick-wrap">
        <ul class="quick-list">
          <!-- 
            2024-12-16
            D : 장바구니랑 최근 본 제품 관련 페이지일때 
            li태그에 is-active 클래스 추가해주세요. 
          -->
          <li v-if="data.quick.menus.includes('qm01')" class="quick-item">
            <a
              href="javascript:void(0);"
              class="anchor"
              @click="btnCmd('orderBasket')"
            >
              <i class="c-icon icon-basket"></i>
              <span class="text">장바구니</span>
              <div class="c-count" v-if="isBasketCount">
                <span>{{ dispBasketCount }}</span>
              </div>
            </a>
          </li>
          <!-- 
            2024-12-16
            D : 장바구니랑 최근 본 제품 관련 페이지일때 
            li태그에 is-active 클래스 추가해주세요. 
          -->
          <li v-if="data.quick.menus.includes('qm02')" class="quick-item">
            <a
              href="javascript:void(0);"
              class="anchor"
              @click="btnCmd('rcentlyViewedProd')"
            >
              <i class="c-icon icon-recent-products"></i>
              <span class="text">최근 본 <br />제품</span>
            </a>
          </li>
          <!-- MEMO: 오픈이후 주석 해제
          <li v-if="data.quick.menus.includes('qm03')" class="quick-item">
            <button
              type="button"
              class="anchor"
              data-popup-open="#CYB_PC_QU_05_00"
              data-quick-fixed
              @click="btnCmd('paintValueCalc')"
            >
              <i class="c-icon icon-calc"></i>
              <span class="text">페인트양 <br />계산하기</span>
            </button>
          </li>
          -->
          <!-- D: 고객센터에서만 미노출 -->
          <li
            v-if="data.quick.menus.includes('qm04')"
            class="quick-item only-pc"
          >
            <a
              href="javascript:void(0);"
              @click="btnCmd('remoteSupport')"
              class="anchor"
            >
              <i class="c-icon icon-remote"></i>
              <span class="text">원격지원</span>
            </a>
          </li>
          <!-- 2024-12-30 메뉴간 위치 변경 -->
          <li
            v-if="
              data.quick.menus.includes('qm05') &&
              Utils.isNotBlank(currentUserManual)
            "
            class="quick-item"
          >
            <!-- 2024-12-16 PDF 연결 -->
            <a
              href="javascript:void(0);"
              class="anchor"
              title="새창"
              target="_blank"
              @click.prevent="openManual"
            >
              <i class="c-icon icon-user-manual"></i>
              <span class="text"
                >사용자 <br />
                매뉴얼</span
              >
            </a>
          </li>
          <!-- //D: 2024-12-23 PC전용 클래스 추가 -->
          <li
            v-if="data.quick.menus.includes('qm06') && videoManuals.length > 0"
            class="quick-item"
          >
            <!-- 2024-12-16 팝업 오픈 유형은 button태그로 변경, data-popup-fixed 속성 추가 -->
            <button
              type="button"
              class="anchor"
              data-popup-open="#CYB_PC_QU_07_00"
              data-quick-fixed
              @click.prevent="btnCmd('movieGuide')"
            >
              <i class="c-icon icon-video-guide"></i>
              <span class="text"
                >동영상 <br />
                가이드</span
              >
            </button>
          </li>
          <!--// 2024-12-30 메뉴간 위치 변경 -->
        </ul>
      </div>
      <!-- // D: 2024-12-23 div Wrap 래핑 추가 -->
    </div>

    <!-- 2024-12-23 dimmed 추가 -->
    <div class="dimmed"></div>
  </nav>
  <paintQuantityCalcPop
    v-if="data.popup.isPaintQuantityCalcPop"
    @close="() => (data.popup.isPaintQuantityCalcPop = false)"
  />
  <videoGuidePop
    v-if="data.popup.isVideoGuidePop && videoManuals.length > 0"
    :manuals="videoManuals"
    @close="() => (data.popup.isVideoGuidePop = false)"
  />
</template>
<script setup name="quickMenu">
import { ref, onMounted, reactive, watch, computed, onUnmounted } from "vue";
import { useRoute } from "vue-router";

import * as store from "@/store";
import router from "../../../router";
import * as cmUtil from "@/utils/cmUtil";
const { isMobile } = cmUtil.useDeviceType();
import Utils from "@/js/utils";
import pageMap from "@/js/pageMap.js";
import paintQuantityCalcPop from "@/components/paintpro/quickMenu/paintQuantityCalcPop.vue";
import videoGuidePop from "@/components/paintpro/quickMenu/videoGuidePop.vue";

const route = useRoute();
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;

const applicationStore = store.useApplicationStore();

const hasButtonFixed = ref(false);

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    isLogin: false,
    userLoginInfo: {},
  },
  popup: {
    isPaintValueCalc: false,
    isRemoteSupport: false,
    isMovieGuide: false,
    isUserManual: false,
    isMoQuickExpanded: false,
    isPaintQuantityCalcPop: false,
    isVideoGuidePop: false,
  },
  quick: {
    basketCount: 0,
    menus: [
      "qm01", // 장바구니
      "qm02", // 최근 본 제품
      "qm03", // 페인트양 계산하기
      "qm04", // 원격지원
      "qm05", // 사용자 메뉴얼
      "qm06", // 동영상 가이드
    ],
  },
  toolbar: {
    alimCount: 0,
  },
});

// watch(
//   () => store.useAlimCountStore().alimCount,
//   (newValue) => {
//     data.toolbar.alimCount = newValue;
//   }
// );

const currentPath = computed(() => {
  return route.path || "";
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.quick.basketCount = newValue;
    4775;
  }
);

// 알림 존재여부
// const isAlimCount = computed(() => {
//   return data.toolbar.alimCount > 0 ? true : false;
// });

// 알림 표시
// const dispAlimCount = computed(() => {
//   return data.toolbar.alimCount > 99 ? "99+" : data.toolbar.alimCount;
// });

// 장바구니 존재여부
const isBasketCount = computed(() => {
  return data.quick.basketCount > 0 ? true : false;
});
// 장바구니 표시
const dispBasketCount = computed(() => {
  return data.quick.basketCount > 99 ? "99+" : data.quick.basketCount;
});

const userManuals = computed(() => {
  return applicationStore.userManuals;
});

const videoManuals = computed(() => {
  // return applicationStore.userManuals
  //   .filter((item) => item.manualTypeCd.includes("VIDEO"))
  //   .filter((item) => Utils.isNotBlank(item.videoUrl));

  const manualPathCodes = [
    {
      // 홈
      path: "/paintpro/main",
      cd: "HOME",
    },
    {
      // 제품주문
      path: "/paintpro/prodList",
      cd: "ORDER",
    },
    {
      // 마이룸
      path: "/paintpro/myRoom",
      cd: "ORDER",
    },
    {
      // 주문현황
      path: "/paintpro/orderList",
      cd: "ORDERINFO",
    },
    {
      // 조색배합
      path: "/paintpro/colorCombinList",
      cd: "COMBINE",
    },
    {
      // 고객센터
      path: "/paintpro/custCenterList",
      cd: "CUSTOM",
    },
    {
      // 장바구니
      path: "/paintpro/orderBasket",
      cd: "CART",
    },
    {
      // 최근본제품
      path: "/paintpro/quickMenu/rcentlyViewedProd",
      cd: "RECENT",
    },
    {
      // 내정보
      path: "/paintpro/utility",
      cd: "MYPAGE",
    },
  ];

  const manualDpPstnCd = manualPathCodes.find((code) =>
    currentPath.value.startsWith(code.path)
  )?.cd;

  if (!manualDpPstnCd) {
    console.warn(
      "현재 경로에 대한 사용자자 메뉴얼 코드를 찾을 수 없습니다.",
      "경로: ",
      currentPath.value
    );
    return [];
  }

  return userManuals.value
    .filter((item) => item.manualTypeCd.includes("VIDEO"))
    .filter((item) => item.manualDpPstnCd === manualDpPstnCd)
    .filter((item) =>
      isMobile.value ? item.dvcMblYn === "Y" : item.dvcPcYn === "Y"
    )
    .filter((item) => Utils.isNotBlank(item.videoUrl));
});

const currentUserManual = computed(() => {
  const manualPathCodes = [
    {
      // 홈
      path: "/paintpro/main",
      cd: "HOME",
    },
    {
      // 제품주문
      path: "/paintpro/prodList",
      cd: "ORDER",
    },
    {
      // 마이룸
      path: "/paintpro/myRoom",
      cd: "ORDER",
    },
    {
      // 주문현황
      path: "/paintpro/orderList",
      cd: "ORDERINFO",
    },
    {
      // 조색배합
      path: "/paintpro/colorCombinList",
      cd: "COMBINE",
    },
    {
      // 고객센터
      path: "/paintpro/custCenterList",
      cd: "CUSTOM",
    },
    {
      // 장바구니
      path: "/paintpro/orderBasket",
      cd: "CART",
    },
    {
      // 최근본제품
      path: "/paintpro/quickMenu/rcentlyViewedProd",
      cd: "RECENT",
    },
    {
      // 내정보
      path: "/paintpro/utility",
      cd: "MYPAGE",
    },
  ];

  const manualDpPstnCd = manualPathCodes.find((code) =>
    currentPath.value.startsWith(code.path)
  )?.cd;

  if (!manualDpPstnCd) {
    console.warn(
      "현재 경로에 대한 사용자 메뉴얼 코드를 찾을 수 없습니다.",
      "경로: ",
      currentPath.value
    );
    return undefined;
  }

  const userManual = userManuals.value
    .filter((item) =>
      isMobile.value ? item.dvcMblYn === "Y" : item.dvcPcYn === "Y"
    )
    .find(
      (item) =>
        item.manualTypeCd.includes("PDF") &&
        item.manualDpPstnCd === manualDpPstnCd
    );

  if (!userManual) {
    console.warn(
      "사용자 메뉴얼을 찾을 수 없습니다.",
      "경로: ",
      currentPath.value,
      "메뉴얼 코드: ",
      manualDpPstnCd,
      "모바일여부: ",
      isMobile.value
    );
  }

  return userManual;
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  data.toolbar.alimCount = cmUtil.getLocalStorage("gv.alimCount");
  data.quick.basketCount = cmUtil.getLocalStorage("gv.basketCount");

  // 고객센터
  if (route.path.includes("/custCenterList")) {
    data.quick.menus = [
      "qm01", // 장바구니
      "qm02", // 최근 본 제품
      "qm03", // 페인트양 계산하기
      // "qm04", // 원격지원
      "qm05", // 사용자 메뉴얼
      "qm06", // 동영상 가이드
    ];
  }

  applicationStore.loadUserManuals();

  // MO 플로팅 버튼 겹침 방지
  // D: 하단 플로팅 버튼체크후 c-quick 클래스 추가
  const observer = new MutationObserver(() => {
    hasButtonFixed.value = !!document.querySelector("[data-bottom-fixed]");
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // 컴포넌트 언마운트 시 옵저버 해제
  onUnmounted(() => {
    observer.disconnect();
  });
});

const openManual = () => {
  if (!currentUserManual.value) return;

  const userManualPath = `${FILE_CDN_URL}${currentUserManual.value.filePath}/${currentUserManual.value.physFileNm}`;
  window.open(userManualPath, "_blank");
};

/**********************
 * 버튼 클릭 모음
 *********************/

async function btnCmd(cmd = "", parms = {}) {
  if (["orderBasket", "rcentlyViewedProd"].includes(cmd)) {
    const pagePath = pageMap.getPagePath(cmd);
    if (pagePath == null) {
      alert(`[개발확인] btnCmd() [${cmd}] 의 pageInfo 정보롤 찾지 못했습니다.`);
      return false;
    }
    if (pagePath.type === "page") {
      router.push({
        path: pagePath.path,
        query: pagePath.query,
      });
    } else if (pagePath.type === "popup") {
      data.popup[pagePath.path] = true;
    } else {
      alert(`[개발확인] btnCmd() [${cmd}] 의 pageInfo 유형이 없습니다..`);
    }
  } else if (cmd == "handleExpand") {
    data.popup.isMoQuickExpanded = !data.popup.isMoQuickExpanded;
  } else if (cmd == "handleGoto") {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } else if (cmd == "paintValueCalc") {
    data.popup.isPaintQuantityCalcPop = !data.popup.isPaintQuantityCalcPop;
  } else if (cmd == "remoteSupport") {
    const _url = "http://ezh.kr/noroo1/";
    window.open(_url, "_blank");
  } else if (cmd == "movieGuide") {
    data.popup.isVideoGuidePop = !data.popup.isVideoGuidePop;
  } else if (cmd == "userManual") {
    const pdfUrl = `${FILE_CDN_URL}/UPLOAD/pdf/paintpro_usermanual.pdf`; // 여기에 실제 PDF 파일 URL을 입력하세요.
    window.open(pdfUrl, "_blank");
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
<style scoped></style>
